module.exports = __webpack_public_path__ + "static/media/exchange.e9106216.svg";